@if (!locationBannerVisible()) {
  <app-install-banner />
}
<app-top-toolbar />
<app-location-banner />

<mat-sidenav-container
  (backdropClick)="shellService.closeSidenavs()"
  class="sidenav-container"
  [class.sidenav-container--side-mode]="deviceService.gtSmScreen()"
  [class.sidenav-container--left-collapsed]="shellService.leftSidenavCollapsed() && deviceService.gtSmScreen()"
>
  <mat-sidenav
    [opened]="shellService.leftSidenavIsOpen$ | async"
    [mode]="deviceService.gtSmScreen() ? 'side' : 'over'"
    [fixedInViewport]="true"
    [fixedTopGap]="
      deviceService.gtXsScreen()
        ? 80 + (locationBannerVisible() ? 48 : 0)
        : 56 + (locationBannerVisible() ? 64 : bannerVisible() ? 79 : 0)
    "
    [fixedBottomGap]="deviceService.isXsScreen() ? 64 : 0"
    [disableClose]="true"
    class="left-sidenav"
    [class.left-sidenav--collapsed]="shellService.leftSidenavCollapsed()"
  >
    <app-left-sidenav />
  </mat-sidenav>

  <mat-sidenav
    [opened]="shellService.rightSidenavIsOpen$ | async"
    [mode]="deviceService.gtSmScreen() ? 'side' : 'over'"
    [fixedInViewport]="true"
    [fixedTopGap]="
      deviceService.gtXsScreen()
        ? 80 + (locationBannerVisible() ? 48 : 0)
        : 56 + (locationBannerVisible() ? 64 : bannerVisible() ? 79 : 0)
    "
    [fixedBottomGap]="deviceService.isXsScreen() ? 64 : 0"
    [disableClose]="true"
    position="end"
    class="right-sidenav"
  >
    <app-right-sidenav />
  </mat-sidenav>

  <!-- DO NOT CHANGE CLASS NAME OF SIDENAV CONTENT OR REMOVE. See shell.component.ts constructor scrollSubscription -->
  <div class="ac-flex-col ac-algn-ctr ac-pd-lg-xl sidenav-content-container">
    <div class="ac-flex-col sidenav-content">
      <router-outlet />

      <app-footer class="footer" />
    </div>
  </div>
</mat-sidenav-container>

<app-promo-banner />

@if (deviceService.isXsScreen()) {
  <app-bottom-toolbar />
}
